// redux/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user', // The name of the slice
  initialState: {user:null}, // The initial state of the slice
  reducers: {
    
    setUser: (state, action) => {
      let user={...action.payload};
      user.displayName=`${user?.displayName ? user?.displayName : 'John Doe'}`;
      state.user=user;
    },
     setToken: (state, action) => {
      state.device_id = action.payload;
    },
    logout: (state) => {
    localStorage.clear();
     state.user=null
    }, // Action to clear the user from the state
  },
});

// Exporting actions
export const { setUser, setToken, logout } = userSlice.actions;
export const selectUser = (state) => state.user.user;
export const selectDeviceId = (state) => state.user.device_id;
// Exporting the reducer
export default userSlice.reducer;
